var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYes = function SvgYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5879_6219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50212 18.498H15.0021C15.6938 18.498 16.2854 18.0813 16.5354 17.4813L19.0521 11.6063C19.1271 11.4146 19.1688 11.2146 19.1688 10.998V9.3313C19.1688 8.41463 18.4188 7.66463 17.5021 7.66463H12.2438L13.0354 3.8563L13.0604 3.58963C13.0604 3.24797 12.9188 2.9313 12.6938 2.7063L11.8104 1.8313L6.31878 7.32297C6.01878 7.62297 5.83545 8.03963 5.83545 8.49797V16.8313C5.83545 17.748 6.58545 18.498 7.50212 18.498ZM7.50212 8.49797L11.1188 4.8813L10.0021 9.3313H17.5021V10.998L15.0021 16.8313H7.50212V8.49797ZM0.835449 8.49797H4.16878V18.498H0.835449V8.49797Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5879_6219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00195312 0.997925)"
  })))));
};
export default SvgYes;